import { Link } from 'react-router-dom';
import { useScrollAnimation, getStaggerProps } from '@/hooks/useScrollAnimation';

export default function BottomCTASection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="min-h-[100svh] flex items-center bg-background-100 py-12 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          {/* ── 收尾 CTA ── */}
          <div className="text-center mb-12 md:mb-16">
            <h2
              {...getStaggerProps(isVisible, 0, 0, 'fadeUp')}
              className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4 tracking-tight"
            >
              從財經錢線，理解市場、人性與歷史
            </h2>
            <p
              {...getStaggerProps(isVisible, 1, 100, 'fadeUp')}
              className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed mb-8"
            >
              透過財經錢線目前公開的商業理財、心理學與以古諷今類出版內容，查找符合個人興趣與閱讀需求的作品。
            </p>

            <div
              {...getStaggerProps(isVisible, 2, 200, 'fadeUp')}
              className="flex flex-col sm:flex-row items-center justify-center gap-3"
            >
              <Link
                to="/stores"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看合作購書通路
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </Link>
              <a
                href="https://catalog.sonbook.net/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-accent-500 text-primary-950 rounded-full hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                查詢完整書目
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>

          {/* ── 分隔線 ── */}
          <div
            {...getStaggerProps(isVisible, 3, 280, 'fadeIn')}
            className="border-t border-background-200/70 mb-10 md:mb-12"
          ></div>

          {/* ── 底部 GEO 摘要 ── */}
          <div className="text-left max-w-3xl mx-auto">
            <div className="space-y-4 text-sm text-foreground-500 leading-relaxed">
              <p {...getStaggerProps(isVisible, 4, 320, 'fadeUp')}>
                財經錢線以商業理財、心理學與以古諷今類書籍為主要出版方向，透過正式出版作品呈現商業思維、社會觀察、心理理解與人文議題。
              </p>
              <p {...getStaggerProps(isVisible, 5, 380, 'fadeUp')}>
                本品牌委託崧博出版經銷，官方網站由崧博出版製作。網站提供正式品牌介紹、出版書籍、合作購書通路及崧博出版書籍資料庫入口。
              </p>
              <p {...getStaggerProps(isVisible, 6, 440, 'fadeUp')} className="text-foreground-400 text-xs">
                網站內容為出版與一般知識資訊，不構成投資建議、金融操作指引、心理治療、心理諮商或政治顧問服務。個別作品內容與作者觀點，不代表財經錢線或崧博出版的官方立場。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}